module.exports = __webpack_public_path__ + "static/mysql-6a497a31680ae301bd74960260039087.png";